module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"deleteBtn":"Supprimer","cancelBtn":"Ne pas supprimer","title":"Supprimer ce lieu temporaire ?","text":"Les restrictions sur ce lieu n\u0027existeront plus et il sera visible de tous les joeurs."},"en":{"deleteBtn":"Remove","cancelBtn":"Do not remove","title":"Remove this temporary place?","text":"The POI will become visible to all players."}}')
  delete Component.options._Ctor
}
